module.exports = __webpack_public_path__ + "static/media/fill_outline.fragment.121fd164.glsl";